import React, { useEffect, useRef, useState } from 'react'
import Sidebar from '../Includes/Sidebar'
import Footer from '../Includes/Footer';
import { Link } from 'react-router-dom';
import GeneralService from '../../services/general.service';
import './Home.css'
import { useSelector } from 'react-redux';

export default function Home({ orders }) {
    const state = useSelector((state) => state.stateVals);
    const { id: adminId } = state;
    const [isLoading, setIsLoading] = useState(true);
    const [contactMessages, setContactMessages] = useState([]);
    const [todaysAppointments, setTodaysAppointments] = useState([]);
    const [newAppointmentAlert, setNewAppointmentAlert] = useState(null);
    const [previousAppointmentCount, setPreviousAppointmentCount] = useState(0);
    const [hasNewNotification, setHasNewNotification] = useState(false);
    const [showNotificationPanel, setShowNotificationPanel] = useState(false);
    
    // Complete notification system states
    const [notifications, setNotifications] = useState([]);
    const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
    const [notificationHistory, setNotificationHistory] = useState([]);
    const [newAppointmentsCount, setNewAppointmentsCount] = useState(0);
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const pollingInterval = useRef(null);

    // Enhanced Audio state management
    const [notificationAudio, setNotificationAudio] = useState(null);
    const [isSoundMuted, setIsSoundMuted] = useState(false);
    const [notificationVolume, setNotificationVolume] = useState(0.8);
    const [audioReady, setAudioReady] = useState(false);
    const [autoSoundEnabled, setAutoSoundEnabled] = useState(true);
    const [soundPlayingTimeout, setSoundPlayingTimeout] = useState(null);
    const audioRef = useRef(null);
    const continuousSoundRef = useRef(null);

    

    const [dashboard, setDashboard] = useState({
        totalStaff: 0,
        activeStaff: 0,
        inactiveStaff: 0,
        totalDoctors: 0,
        availableDoctors: 0,
        busyDoctors: 0,
        totalAppointments: 0,
        pendingAppointments: 0,
        completedAppointments: 0,
        cancelledAppointments: 0,
        totalMessages: 0,
        unreadMessages: 0,
        readMessages: 0,
        todayAppointments: 0,
        weekAppointments: 0,
        monthAppointments: 0,
        unreadNotifications: 0,
    });

    // Storage keys for persistent data
    const STORAGE_KEYS = {
        NEW_APPOINTMENTS_COUNT: 'newAppointmentsCount',
        LAST_APPOINTMENT_COUNT: 'lastAppointmentCount',
        NOTIFICATION_HISTORY: 'notificationHistory',
        NOTIFICATIONS: 'notifications',
        UNREAD_COUNT: 'unreadNotificationCount'
    };

    // Load persistent data from session storage
  const loadPersistentData = async () => {
    try {
        // Load from API instead of session storage
        await fetchNotifications();
        await fetchUnreadCount();
        
        // Still load some local data for UI state
        const savedNewCount = sessionStorage.getItem(STORAGE_KEYS.NEW_APPOINTMENTS_COUNT);
        const savedLastCount = sessionStorage.getItem(STORAGE_KEYS.LAST_APPOINTMENT_COUNT);

        if (savedNewCount) {
            setNewAppointmentsCount(parseInt(savedNewCount, 10));
        }
        if (savedLastCount) {
            setPreviousAppointmentCount(parseInt(savedLastCount, 10));
        }

        console.log('📱 Loaded data from API and session storage');
    } catch (error) {
        console.error('❌ Error loading persistent data:', error);
    }
};

    // Save persistent data to session storage
    const savePersistentData = () => {
        try {
            sessionStorage.setItem(STORAGE_KEYS.NEW_APPOINTMENTS_COUNT, newAppointmentsCount.toString());
            sessionStorage.setItem(STORAGE_KEYS.LAST_APPOINTMENT_COUNT, previousAppointmentCount.toString());
            sessionStorage.setItem(STORAGE_KEYS.NOTIFICATION_HISTORY, JSON.stringify(notificationHistory));
            sessionStorage.setItem(STORAGE_KEYS.NOTIFICATIONS, JSON.stringify(notifications));
            sessionStorage.setItem(STORAGE_KEYS.UNREAD_COUNT, unreadNotificationCount.toString());
            
            console.log('💾 Saved persistent notification data:', {
                newCount: newAppointmentsCount,
                lastCount: previousAppointmentCount,
                unreadCount: unreadNotificationCount
            });
        } catch (error) {
            console.error('❌ Error saving persistent data:', error);
        }
    };

    // Save data whenever key states change
    useEffect(() => {
        savePersistentData();
    }, [newAppointmentsCount, previousAppointmentCount, notificationHistory, notifications, unreadNotificationCount]);

    // Initialize audio when component mounts
    useEffect(() => {
        initializeAudio();
        loadPersistentData();

        // Request notification permission
        if ('Notification' in window && Notification.permission === 'default') {
            Notification.requestPermission();
        }

        return () => {
            // Cleanup audio and timers
            if (audioRef.current) {
                if (typeof audioRef.current.pause === 'function') {
                    audioRef.current.pause();
                }
                audioRef.current = null;
            }
            if (continuousSoundRef.current) {
                clearInterval(continuousSoundRef.current);
            }
            if (soundPlayingTimeout) {
                clearTimeout(soundPlayingTimeout);
            }
        };
    }, []);


    // 1. Update the state to track unread appointment notifications
const [unreadAppointmentNotifications, setUnreadAppointmentNotifications] = useState([]);


// 2. Add function to fetch unread appointment notifications
const fetchUnreadAppointmentNotifications = async () => {
    try {
        const response = await GeneralService.getNotifications(true, 1, 50); // unread_only=true
        if (response.data && response.data.success) {
            const appointmentNotifications = response.data.data.notifications.filter(
                notif => notif.type === 'appointment' || notif.notification_type === 'appointment_booking'
            );
            setUnreadAppointmentNotifications(appointmentNotifications);
            console.log('📋 Unread appointment notifications:', appointmentNotifications.length);
        }
    } catch (error) {
        console.error('❌ Error fetching unread appointment notifications:', error);
    }
};



    // Frontend notification functions (replacing backend calls)
    const createNotification = (type, title, message, data = {}) => {
        const notification = {
            id: Date.now() + Math.random(),
            type: type,
            title: title,
            message: message,
            data: data,
            is_read: false,
            created_at: new Date().toISOString(),
            read_at: null
        };

        setNotifications(prev => [notification, ...prev].slice(0, 50)); // Keep only 50 latest
        setUnreadNotificationCount(prev => prev + 1);
        
        return notification;
    };

const fetchNotifications = async () => {
    try {
        const response = await GeneralService.getNotifications(false, 1, 50);
        if (response.data && response.data.success) {
            setNotifications(response.data.data.notifications || []);
            setUnreadNotificationCount(response.data.data.unread_count || 0);
            console.log('📋 Notifications fetched from API:', response.data.data.notifications.length);
        }
    } catch (error) {
        console.error('❌ Error fetching notifications:', error);
    }
};

  const fetchUnreadCount = async () => {
    try {
        const response = await GeneralService.getUnreadCount();
        if (response.data && response.data.success) {
            setUnreadNotificationCount(response.data.unread_count || 0);
            console.log('📊 Unread count fetched from API:', response.data.unread_count);
        }
    } catch (error) {
        console.error('❌ Error fetching unread count:', error);
    }
};

const markAllNotificationsAsRead = async () => {
    try {
        const response = await GeneralService.markAllAsRead();
        if (response.data && response.data.success) {
            setNotifications(prev => 
                prev.map(notif => ({
                    ...notif,
                    is_read: true,
                    read_at: new Date().toISOString()
                }))
            );
            setUnreadNotificationCount(0);
            stopContinuousNotificationSound();
            console.log('📖 All notifications marked as read via API');
        }
    } catch (error) {
        console.error('❌ Error marking all notifications as read:', error);
    }
};

   const markNotificationAsRead = async (notificationId) => {
    try {
        const response = await GeneralService.markAsRead(notificationId);
        if (response.data && response.data.success) {
            setNotifications(prev =>
                prev.map(notif =>
                    notif.id === notificationId
                        ? { ...notif, is_read: true, read_at: new Date().toISOString() }
                        : notif
                )
            );
            setUnreadNotificationCount(prev => Math.max(0, prev - 1));
            console.log('📖 Notification marked as read via API:', notificationId);
        }
    } catch (error) {
        console.error('❌ Error marking notification as read:', error);
    }
};

const deleteNotification = async (notificationId) => {
    try {
        const response = await GeneralService.deleteNotification(notificationId);
        if (response.data && response.data.success) {
            const notification = notifications.find(n => n.id === notificationId);
            if (notification && !notification.is_read) {
                setUnreadNotificationCount(prev => Math.max(0, prev - 1));
            }
            
            setNotifications(prev => prev.filter(notif => notif.id !== notificationId));
            console.log('🗑️ Notification deleted via API:', notificationId);
        }
    } catch (error) {
        console.error('❌ Error deleting notification:', error);
    }
};

 // Replace the existing deleteAllReadNotifications function
const deleteAllReadNotifications = async () => {
    try {
        const response = await GeneralService.deleteAllReadNotifications();
        if (response.data && response.data.success) {
            setNotifications(prev => prev.filter(notif => !notif.is_read));
            console.log('🗑️ All read notifications deleted via API');
        }
    } catch (error) {
        console.error('❌ Error deleting all read notifications:', error);
    }
};

    // Monitor appointment count changes for automatic sound and notifications
    useEffect(() => {
        const currentCount = dashboard.todayAppointments;

        // Only trigger if we have a previous count, current count is greater, and it's not initial load
        if (!isInitialLoad && previousAppointmentCount > 0 && currentCount > previousAppointmentCount && autoSoundEnabled) {
            const newCount = currentCount - previousAppointmentCount;
            console.log(`🔔 Auto Sound Triggered: ${previousAppointmentCount} → ${currentCount} (${newCount} new)`);
            
            // Create notification for new appointments
            const notification = createNotification(
                'appointment_new',
                'New Appointments Detected!',
                `${newCount} new appointment${newCount > 1 ? 's' : ''} booked today`,
                {
                    appointment_count: newCount,
                    total_today: currentCount
                }
            );

            // Update new appointments count
            setNewAppointmentsCount(prev => prev + newCount);
            startContinuousNotificationSound();

            // Show visual alert
            setNewAppointmentAlert({
                id: Date.now(),
                patientName: `${newCount} new appointment${newCount > 1 ? 's' : ''}`,
                doctorName: 'Check your appointment list',
                time: new Date().toISOString(),
                timestamp: Date.now(),
                autoGenerated: true
            });

            // Auto-dismiss visual alert after 10 seconds
            setTimeout(() => {
                setNewAppointmentAlert(null);
            }, 10000);
        }

        // Update previous count
        if (currentCount !== previousAppointmentCount) {
            setPreviousAppointmentCount(currentCount);
        }

        // Mark initial load as complete after first data fetch
        if (isInitialLoad && currentCount >= 0) {
            setIsInitialLoad(false);
        }
    }, [dashboard.todayAppointments, autoSoundEnabled, previousAppointmentCount, isInitialLoad]);

    // Initialize audio with fallback options
    const initializeAudio = () => {
        try {
            const audio = new Audio();
            const audioPath = 'https://res.cloudinary.com/dll4d2yu7/video/upload/v1750578996/nexusgenSoftware/notification-alert_s3hutz.mp3';
            audio.src = audioPath;
            audio.volume = notificationVolume;
            audio.preload = 'auto';
            audio.loop = false;

            audio.addEventListener('canplaythrough', () => {
                audioRef.current = audio;
                setAudioReady(true);
                console.log('🔊 Audio file loaded successfully');
            });

            audio.addEventListener('error', (e) => {
                console.log('🔊 Audio file failed, using beep sound');
                createBeepSound();
            });

            audio.load();

        } catch (error) {
            console.log('🔊 Audio initialization error, using beep fallback');
            createBeepSound();
        }
    };

    // Create a programmatic beep sound using Web Audio API
    const createBeepSound = () => {
        try {
            const AudioContext = window.AudioContext || window.webkitAudioContext;

            const createBeep = () => {
                const audioContext = new AudioContext();

                const oscillator1 = audioContext.createOscillator();
                const oscillator2 = audioContext.createOscillator();
                const gainNode = audioContext.createGain();

                oscillator1.connect(gainNode);
                oscillator2.connect(gainNode);
                gainNode.connect(audioContext.destination);

                oscillator1.frequency.value = 800;
                oscillator2.frequency.value = 600;
                oscillator1.type = 'sine';
                oscillator2.type = 'sine';

                gainNode.gain.setValueAtTime(0, audioContext.currentTime);
                gainNode.gain.linearRampToValueAtTime(notificationVolume * 0.3, audioContext.currentTime + 0.1);
                gainNode.gain.exponentialRampToValueAtTime(0.001, audioContext.currentTime + 0.8);

                oscillator1.start(audioContext.currentTime);
                oscillator2.start(audioContext.currentTime);
                oscillator1.stop(audioContext.currentTime + 0.8);
                oscillator2.stop(audioContext.currentTime + 0.8);
            };

            audioRef.current = { play: createBeep };
            setAudioReady(true);
            console.log('🔊 Enhanced beep sound created');
        } catch (error) {
            console.log('🔊 Web Audio API error:', error);
            setAudioReady(false);
        }
    };

    // Single sound play function
    const playNotificationSound = async () => {
        if (isSoundMuted || !audioReady) {
            console.log('🔇 Sound is muted or not ready');
            return;
        }

        try {
            if (audioRef.current) {
                if (audioRef.current instanceof Audio) {
                    audioRef.current.currentTime = 0;
                    audioRef.current.volume = notificationVolume;

                    const playPromise = audioRef.current.play();
                    if (playPromise !== undefined) {
                        playPromise
                            .then(() => {
                                console.log('🔊 Audio file played successfully');
                            })
                            .catch(error => {
                                console.log('🔊 Audio play failed, trying beep:', error);
                                createEmergencyBeep();
                            });
                    }
                } else if (audioRef.current.play && typeof audioRef.current.play === 'function') {
                    audioRef.current.play();
                    console.log('🔊 Beep sound played');
                }
            }
        } catch (error) {
            console.log('🔊 Error playing sound:', error);
            createEmergencyBeep();
        }
    };

    // Continuous notification sound that auto-stops
    const startContinuousNotificationSound = () => {
        if (isSoundMuted || !audioReady || !autoSoundEnabled) {
            console.log('🔇 Auto sound disabled or not ready');
            return;
        }

        console.log('🔊 Starting continuous notification sound...');

        // Clear any existing continuous sound
        stopContinuousNotificationSound();

        // Play first sound immediately
        playNotificationSound();

        // Set up repeating sound every 2 seconds
        continuousSoundRef.current = setInterval(() => {
            playNotificationSound();
        }, 2000);

        // Auto-stop after 30 seconds
        setSoundPlayingTimeout(setTimeout(() => {
            stopContinuousNotificationSound();
            console.log('🔇 Auto-stopped continuous notification sound after 30 seconds');
        }, 30000));
    };

    // Stop continuous sound
    const stopContinuousNotificationSound = () => {
        if (continuousSoundRef.current) {
            clearInterval(continuousSoundRef.current);
            continuousSoundRef.current = null;
        }
        if (soundPlayingTimeout) {
            clearTimeout(soundPlayingTimeout);
            setSoundPlayingTimeout(null);
        }
        console.log('🔇 Stopped continuous notification sound');
    };

    // Emergency beep fallback
    const createEmergencyBeep = () => {
        try {
            const AudioContext = window.AudioContext || window.webkitAudioContext;
            const audioContext = new AudioContext();
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();

            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);

            oscillator.frequency.value = 800;
            oscillator.type = 'sine';
            gainNode.gain.setValueAtTime(notificationVolume * 0.3, audioContext.currentTime);
            gainNode.gain.exponentialRampToValueAtTime(0.001, audioContext.currentTime + 0.3);

            oscillator.start();
            oscillator.stop(audioContext.currentTime + 0.3);
            console.log('🔊 Emergency beep played');
        } catch (fallbackError) {
            console.log('🔊 All audio methods failed:', fallbackError);
        }
    };

    const testNotificationSound = () => {
        console.log('🔊 Testing single notification sound...');
        playNotificationSound();
    };

    // Test continuous sound
    const testContinuousSound = () => {
        console.log('🔊 Testing continuous notification sound...');
        startContinuousNotificationSound();
    };

    // Enhanced notification display with sound
    const showNewAppointmentNotification = (appointment) => {
        console.log('🔔 New appointment notification:', appointment);

        // Create notification
        createNotification(
            'appointment_individual',
            'New Appointment Booked!',
            `${appointment.patient_name || 'Unknown Patient'} with Dr. ${appointment.doctor_name || 'Unknown Doctor'}`,
            {
                appointment_id: appointment.id,
                patient_name: appointment.patient_name,
                doctor_name: appointment.doctor_name,
                appointment_time: appointment.appointment_time
            }
        );

        // Play single sound for individual appointments
        playNotificationSound();

        setNewAppointmentAlert({
            id: appointment.id,
            patientName: appointment.patient_name || 'Unknown Patient',
            doctorName: appointment.doctor_name || 'Unknown Doctor',
            time: appointment.appointment_time,
            timestamp: Date.now(),
            autoGenerated: false
        });

        setTimeout(() => {
            setNewAppointmentAlert(null);
        }, 10000);

        if ('Notification' in window && Notification.permission === 'granted') {
            try {
                new Notification('🎉 New Appointment Booked!', {
                    body: `${appointment.patient_name || 'Unknown Patient'} with Dr. ${appointment.doctor_name || 'Unknown Doctor'}`,
                    icon: '/favicon.ico',
                    tag: 'appointment-notification',
                    silent: false,
                    requireInteraction: false
                });
            } catch (error) {
                console.log('Browser notification error:', error);
            }
        }
    };

    // Sound control functions
    const toggleNotificationSound = () => {
        const newMutedState = !isSoundMuted;
        setIsSoundMuted(newMutedState);

        // If muting, stop any continuous sound
        if (newMutedState) {
            stopContinuousNotificationSound();
        }

        console.log(`🔊 Sound ${newMutedState ? 'muted' : 'unmuted'}`);

        if (!newMutedState && audioReady) {
            setTimeout(() => {
                playNotificationSound();
            }, 300);
        }
    };

    // Toggle auto sound feature
    const toggleAutoSound = () => {
        const newAutoSoundState = !autoSoundEnabled;
        setAutoSoundEnabled(newAutoSoundState);

        // If disabling, stop any continuous sound
        if (!newAutoSoundState) {
            stopContinuousNotificationSound();
        }

        console.log(`🔔 Auto sound ${newAutoSoundState ? 'enabled' : 'disabled'}`);
    };

    const updateNotificationVolume = (newVolume) => {
        setNotificationVolume(newVolume);
        if (audioRef.current && audioRef.current instanceof Audio) {
            audioRef.current.volume = newVolume;
        }
    };

    // Modified function - only clear when "View All" is clicked
    const markAppointmentsAsRead = () => {
        setNewAppointmentsCount(0);
        stopContinuousNotificationSound(); // Stop any playing sounds
        
        // Clear from session storage
        sessionStorage.removeItem(STORAGE_KEYS.NEW_APPOINTMENTS_COUNT);
        
        console.log('📖 Appointments marked as read - notification cleared');
    };

   // 3. Update the handleViewAllAppointments function
const handleViewAllAppointments = async () => {
    try {
        // Mark all unread appointment notifications as read
        if (unreadAppointmentNotifications.length > 0) {
            await markAllNotificationsAsRead();
            setUnreadAppointmentNotifications([]);
        }
        
        markAppointmentsAsRead();
        console.log('📖 All appointment notifications marked as read');
    } catch (error) {
        console.error('❌ Error marking notifications as read:', error);
    }
};

    const formatDateTime = (dateString) => {
        if (!dateString) return 'N/A';
        return new Date(dateString).toLocaleString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const truncateMessage = (message, maxLength = 50) => {
        if (!message) return 'N/A';
        return message.length > maxLength ? message.substring(0, maxLength) + '...' : message;
    };

    const handleBellClick = () => {
        setShowNotificationPanel(!showNotificationPanel);
        setHasNewNotification(false);
    };

    const dismissNotification = () => {
        setNewAppointmentAlert(null);
        // Also stop continuous sound when manually dismissing
        stopContinuousNotificationSound();
    };

    // Enhanced appointment fetching
const fetchTodaysAppointments = async (showAlert = false) => {
    try {
        const response = await GeneralService.getTodaysAppointments();

        if (response.data && Array.isArray(response.data.appointments)) {
            const appointments = response.data.appointments;
            const currentCount = appointments.length;

            console.log(`📊 Appointments - Current: ${currentCount}, Previous: ${previousAppointmentCount}`);

            if (showAlert && currentCount > previousAppointmentCount && previousAppointmentCount > 0 && !isInitialLoad) {
                const newAppointments = appointments.slice(0, currentCount - previousAppointmentCount);

                console.log(`🆕 Found ${newAppointments.length} new appointments`);

                // Refresh notifications to get the latest from API
                await fetchNotifications();
                await fetchUnreadCount();

                newAppointments.forEach((appointment, index) => {
                    setTimeout(() => {
                        showNewAppointmentNotification(appointment);
                    }, index * 1500);
                });

                setHasNewNotification(true);
            }

            setTodaysAppointments(appointments.slice(0, 5));

            setDashboard(prev => ({
                ...prev,
                todayAppointments: currentCount
            }));
        }
    } catch (error) {
        console.error("❌ Error fetching appointments:", error);
    }
};

    const fetchContactMessages = async () => {
        try {
            setIsLoading(true);
            const response = await GeneralService.getContactMessages();

            if (response.data && Array.isArray(response.data.messages)) {
                const sortedMessages = response.data.messages
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                    .slice(0, 10);

                setContactMessages(sortedMessages);
            } else if (Array.isArray(response.data)) {
                const sortedMessages = response.data
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                    .slice(0, 10);

                setContactMessages(sortedMessages);
            } else {
                console.error("Unexpected response format:", response.data);
                setContactMessages([]);
            }
        } catch (error) {
            console.error("Error fetching contact messages:", error);
            setContactMessages([]);
        } finally {
            setIsLoading(false);
        }
    };

   const fetchCounters = async () => {
    try {
        const response = await GeneralService.dashboardCounters();

        if (response.data && response.data.data) {
            // Fetch latest unread count from notifications API
            const unreadResponse = await GeneralService.getUnreadCount();
            const apiUnreadCount = unreadResponse.data?.unread_count || 0;

            setDashboard(prev => ({
                ...prev,
                totalStaff: response.data.data.total_staff || 0,
                activeStaff: response.data.data.active_staff || 0,
                inactiveStaff: response.data.data.inactive_staff || 0,
                totalDoctors: response.data.data.total_doctors || 0,
                availableDoctors: response.data.data.available_doctors || 0,
                busyDoctors: response.data.data.busy_doctors || 0,
                totalAppointments: response.data.data.total_appointments || 0,
                pendingAppointments: response.data.data.pending_appointments || 0,
                completedAppointments: response.data.data.completed_appointments || 0,
                cancelledAppointments: response.data.data.cancelled_appointments || 0,
                totalMessages: response.data.data.total_messages || 0,
                unreadMessages: response.data.data.unread_messages || 0,
                readMessages: response.data.data.read_messages || 0,
                todayAppointments: response.data.data.today_appointments || 0,
                weekAppointments: response.data.data.week_appointments || 0,
                monthAppointments: response.data.data.month_appointments || 0,
                unreadNotifications: apiUnreadCount, // Use API count
            }));
        }
    } catch (error) {
        console.error('Error fetching dashboard counters:', error);
    }
};

// 4. Update the useEffect for polling to include notification fetching
useEffect(() => {
    fetchContactMessages();
    fetchCounters();
    fetchTodaysAppointments(false);
    
    // Load notifications from API
    loadPersistentData();
    fetchUnreadAppointmentNotifications(); // Add this line

    pollingInterval.current = setInterval(() => {
        fetchTodaysAppointments(true);
        fetchCounters();
        fetchNotifications();
        fetchUnreadCount();
        fetchUnreadAppointmentNotifications(); // Add this line
    }, 10000);

    return () => {
        if (pollingInterval.current) {
            clearInterval(pollingInterval.current);
        }
    };
}, []);

    const cardData = [
        {
            label: "Total Staff",
            value: dashboard.totalStaff,
            icon: "fa-users-cog",
            gradient: "gradient-blue",
            link: "/view-staff"
        },
        {
            label: "Total Doctors",
            value: dashboard.totalDoctors,
            icon: "fa-user-md",
            gradient: "gradient-green",
            link: "/doctors-list"
        },
        {
            label: "Total Appointments",
            value: dashboard.totalAppointments,
            icon: "fa-calendar-check",
            gradient: "gradient-purple",
            link: "/view-appointment"
        },
        {
            label: "Pending Appointments",
            value: dashboard.pendingAppointments,
            icon: "fa-clock",
            gradient: "gradient-orange",
            link: "/view-appointment?status=pending"
        },
        {
            label: "Total Messages",
            value: dashboard.totalMessages,
            icon: "fa-envelope",
            gradient: "gradient-red",
            link: "/messages"
        },
        {
            label: "This Month",
            value: dashboard.monthAppointments,
            icon: "fa-calendar-alt",
            gradient: "gradient-indigo",
        },
    ];

    const unreadNotifications = notifications.filter(n => !n.is_read).length;
    const isContinuousSoundPlaying = continuousSoundRef.current !== null;

    return (
        <>
            {/* Enhanced New Appointment Alert */}
            {newAppointmentAlert && (
                <div className="notification-alert">
                    <div className={`alert alert-dismissible fade show notification-popup enhanced-notification ${newAppointmentAlert.autoGenerated ? 'alert-warning' : 'alert-success'}`} role="alert">
                        <div className="notification-content">
                            <div className="notification-icon-wrapper">
                                <i className={`fa ${newAppointmentAlert.autoGenerated ? 'fa-exclamation-triangle' : 'fa-bell'} fa-2x ${newAppointmentAlert.autoGenerated ? 'text-warning' : 'text-warning'} notification-bell-icon`}></i>
                                <div className="notification-pulse"></div>
                            </div>
                            <div className="notification-details">
                                <div className="notification-header">
                                    <h5 className="alert-heading mb-2">
                                        <i className={`fa ${newAppointmentAlert.autoGenerated ? 'fa-bell-o' : 'fa-calendar-plus'} me-2`}></i>
                                        {newAppointmentAlert.autoGenerated ? '🔔 New Appointment Successfully Booked!' : '🎉 Appointment Updated Successfully!'}
                                    </h5>
                                    <div className="mt-3 d-flex gap-2">
                                        <button className="btn btn-sm btn-outline-primary">
                                            <i className="fa fa-eye me-1"></i>
                                            View Details
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button
                            type="button"
                            className="btn-close notification-close"
                            onClick={dismissNotification}
                            aria-label="Close notification"
                            title="Close this notification"
                        ></button>
                    </div>
                </div>
            )}

            
            <div className="content">
                <Sidebar />

                <div className="container-fluid pt-4 px-4">
                    <div className="row g-4">
                     {cardData.map((item, index) => (
    <div className="col-sm-4 col-xl-4" key={index}>
        <div className="dashboard-card">
            <Link to={item.link} className="text-decoration-none">
                <div className="glass-content">
                    <div className="icon-wrapper">
                        <i className={`fa ${item.icon} fa-3x ${item.gradient}`}></i>
                    </div>
                    <div className="ms-3 text-wrapper">
                        <p className="mb-2 card-label">{item.label}</p>
                        <h6 className="mb-0 card-value">{item.value}</h6>
                    </div>
                </div>
            </Link>
        </div>
    </div>
))}
                    </div>
                </div>

                {/* Today's Appointments Section with Enhanced Sound Controls */}
                 <div className="container-fluid pt-4 px-4">
                    <div className="row g-4">
                        <div className="col-12">
                            <div className="enhanced-appointments-container">
                                <div className="appointments-header">
                                    <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
    <div className="appointment-icon-wrapper">
        <i className="fa fa-calendar-check fa-2x text-white"></i>
        {/* Show unread appointment notifications badge */}
        {unreadAppointmentNotifications.length > 0 && (
            <span className="appointment-badge">
                {unreadAppointmentNotifications.length}
            </span>
        )}
    </div>
    <div className="ms-3">
        <h5 className="mb-0 appointment-title">
            Today's Appointments
        </h5>
        <p className="mb-0 text-muted">
            Manage your daily schedule
            {isContinuousSoundPlaying && (
                <span className="ms-2 badge bg-warning">
                    <i className="fa fa-volume-up me-1"></i>
                    Sound Playing
                </span>
            )}
            {unreadAppointmentNotifications.length > 0 && (
                <span className="ms-2 badge bg-danger">
                    <i className="fa fa-bell me-1"></i>
                    {unreadAppointmentNotifications.length} Unread Notifications
                </span>
            )}
        </p>
    </div>
</div>

                                        <div className="d-flex align-items-center">
                                            {/* Stop Continuous Sound Button */}
                                            {isContinuousSoundPlaying && (
                                                <div className="d-flex align-items-center me-3">
                                                    <button
                                                        onClick={stopContinuousNotificationSound}
                                                        className="btn btn-danger btn-sm"
                                                        title="Stop Continuous Sound"
                                                    >
                                                        <i className="fa fa-stop me-1"></i>
                                                        Stop Sound
                                                    </button>
                                                </div>
                                            )}

                                            {/* Mark as Read Button - Only shows when there are new appointments */}
                                      {unreadAppointmentNotifications.length > 0 && (
    <div className="d-flex align-items-center me-3">
        <button
            onClick={async () => {
                await markAllNotificationsAsRead();
                setUnreadAppointmentNotifications([]);
                markAppointmentsAsRead();
            }}
            className="btn btn-success btn-sm"
            title="Mark all appointment notifications as read"
        >
            <i className="fa fa-check me-1"></i>
            Mark Read ({unreadAppointmentNotifications.length})
        </button>
    </div>
)}

                                            {/* Auto-refresh indicator */}
                                            <div className="d-flex align-items-center me-3 text-muted">
                                                <i className="fa fa-sync-alt me-2 auto-refresh-icon"></i>
                                                <small>Auto-refresh: 10s</small>
                                            </div>

                                            {/* View All Button */}
                                      <Link
    className="btn btn-gradient-primary btn-sm"
    to="/view-appointment"
    onClick={handleViewAllAppointments}
>
    <i className="fa fa-eye me-1"></i>
    View All
</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Recent Messages Section */}
                <div className="container-fluid pt-4 px-4">
                    <div className="bg-light text-center rounded p-4 bg-color">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h5 className="mb-0">
                                Recent Contact Messages <span className="number-records">({contactMessages.length})</span>
                            </h5>
                            <Link className="show-all" to="/contact-messages">Show All</Link>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-striped table-hover">
                                <thead className="bg-gred">
                                    <tr className="text-dark">
                                        <th>No</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Subject</th>
                                        <th>Message</th>
                                        <th>Created At</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {isLoading ? (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : contactMessages.length > 0 ? (
                                        contactMessages.map((message, index) => (
                                            <tr key={message.id}>
                                                <td>{index + 1}</td>
                                                <td>{message.name || 'N/A'}</td>
                                                <td>{message.email || 'N/A'}</td>
                                                <td>{message.subject || 'N/A'}</td>
                                                <td title={message.message}>
                                                    {truncateMessage(message.message)}
                                                </td>
                                                <td>{formatDateTime(message.created_at)}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">No contact messages found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>

            <style jsx>{`
                .notification-alert {
                    position: fixed;
                    top: 20px;
                    right: 20px;
                    z-index: 9999;
                    min-width: 400px;
                    max-width: 500px;
                    animation: slideInRight 0.5s ease-out;
                }

                .enhanced-notification {
                    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
                    border: none;
                    border-radius: 15px;
                    box-shadow: 0 20px 40px rgba(40, 167, 69, 0.3);
                    border-left: 5px solid #155724;
                    overflow: hidden;
                    position: relative;
                }

                .enhanced-notification::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    height: 3px;
                    background: linear-gradient(90deg, #ffc107, #28a745, #17a2b8);
                    animation: progressBar 8s linear;
                }

                .notification-content {
                    display: flex;
                    align-items: flex-start;
                    padding: 20px;
                    color: white;
                }

                .notification-icon-wrapper {
                    position: relative;
                    margin-right: 15px;
                    animation: bounce 2s infinite;
                }

                .notification-bell-icon {
                    color: #ffc107;
                    filter: drop-shadow(0 0 10px rgba(255, 193, 7, 0.5));
                }

                .notification-pulse {
                    position: absolute;
                    top: -5px;
                    right: -5px;
                    width: 20px;
                    height: 20px;
                    background: #ffc107;
                    border-radius: 50%;
                    animation: pulse 1.5s infinite;
                }

                .notification-details {
                    flex: 1;
                }

                .notification-header h5 {
                    color: white;
                    font-weight: 600;
                    margin-bottom: 10px;
                }

                .notification-body > div {
                    margin-bottom: 8px;
                    padding: 5px 0;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                }

                .notification-body > div:last-child {
                    border-bottom: none;
                }

                .notification-close {
                    position: absolute;
                    top: 10px;
                    right: 15px;
                    color: white;
                    opacity: 0.8;
                    font-size: 1.2rem;
                }

                .notification-close:hover {
                    opacity: 1;
                    transform: scale(1.1);
                }

                .enhanced-appointments-container {
                    background: rgba(255, 255, 255, 0.07);
                    border-radius: 20px;
                    padding: 1.5rem;
                    border: 1px solid rgba(255, 255, 255, 0.12);
                    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.35);
                    transition: all 0.3s ease;
                }

                .appointments-header {
                    background: transparent;
                    padding: 1.75rem;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                }

                .appointment-icon-wrapper {
                    position: relative;
                    background: linear-gradient(135deg, #ff5722, #f44336);
                    padding: 1rem;
                    border-radius: 15px;
                    box-shadow: 0 10px 25px rgba(255, 87, 34, 0.35);
                }

                .appointment-badge {
                    position: absolute;
                    top: -8px;
                    right: -8px;
                    background: #f50000;
                    color: white;
                    border-radius: 50%;
                    width: 24px;
                    height: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.75rem;
                    font-weight: bold;
                    animation: pulse 2s infinite;
                }

                .appointment-title {
                    color: #f44336;
                    font-size: 1.6rem;
                    font-weight: 600;
                    text-shadow: 0 10px 25px rgba(255, 87, 34, 0.35);
                }

                .notification-bell {
                    background: rgba(255, 255, 255, 0.1);
                    border: none;
                    border-radius: 12px;
                    padding: 0.75rem;
                    color: white;
                    transition: all 0.3s ease;
                    position: relative;
                }

                .notification-bell:hover {
                    background: rgba(255, 255, 255, 0.25);
                    transform: scale(1.05);
                }

                .notification-bell.has-notification {
                    background: linear-gradient(135deg, #ff6b6b, #ff2e2e);
                    animation: bellShake 1s infinite;
                    box-shadow: 0 0 15px rgba(255, 50, 50, 0.5);
                }

                .notification-count-badge {
                    position: absolute;
                    top: -8px;
                    right: -8px;
                    background: #ff0000;
                    color: white;
                    border-radius: 50%;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.7rem;
                    font-weight: bold;
                    animation: ping 1s infinite;
                    border: 2px solid white;
                }

                .notification-panel {
                    position: absolute;
                    top: 100%;
                    right: 0;
                    width: 350px;
                    background: rgba(40, 40, 40, 0.95);
                    border: 1px solid rgba(255, 255, 255, 0.08);
                    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4);
                    color: white;
                    border-radius: 15px;
                    margin-top: 10px;
                    backdrop-filter: blur(10px);
                    animation: slideDown 0.3s ease-out;
                }

                .notification-panel-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 1rem;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    border-radius: 15px 15px 0 0;
                }

                .notification-panel-body {
                    max-height: 300px;
                    overflow-y: auto;
                    padding: 0.5rem;
                }

                .notification-item {
                    display: flex;
                    align-items: flex-start;
                    background: rgba(255, 255, 255, 0.04);
                    border-radius: 12px;
                    padding: 0.75rem;
                    margin-bottom: 0.5rem;
                    transition: all 0.3s;
                    cursor: pointer;
                    border-left: 3px solid transparent;
                }

                .notification-item:hover {
                    background: rgba(255, 255, 255, 0.08);
                    transform: translateX(3px);
                }

                .notification-item.unread {
                    background: rgba(74, 144, 226, 0.1);
                    border-left-color: #4a90e2;
                }

                .notification-item.unread:hover {
                    background: rgba(74, 144, 226, 0.15);
                }

                .notification-dot-indicator {
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    margin-right: 10px;
                    margin-top: 5px;
                    flex-shrink: 0;
                }

                .notification-panel-footer {
                    padding: 0.75rem 1rem;
                    border-top: 1px solid rgba(255, 255, 255, 0.1);
                    text-align: center;
                    background: rgba(255, 255, 255, 0.02);
                    border-radius: 0 0 15px 15px;
                }

                .btn-gradient-primary {
                    background: linear-gradient(135deg, #201607, #e30613);
                    border: none;
                    color: white;
                    padding: 0.5rem 1rem;
                    border-radius: 10px;
                    font-weight: 500;
                    transition: all 0.3s ease;
                }

                .btn-gradient-primary:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 10px 25px rgba(255, 123, 0, 0.5);
                    color: white;
                }

                .auto-refresh-icon {
                    color: #ffffffcc;
                    animation: spin 2s linear infinite;
                }

                /* Animations */
                @keyframes slideInRight {
                    from {
                        transform: translateX(100%);
                        opacity: 0;
                    }
                    to {
                        transform: translateX(0);
                        opacity: 1;
                    }
                }

                @keyframes slideDown {
                    from {
                        transform: translateY(-10px);
                        opacity: 0;
                    }
                    to {
                        transform: translateY(0);
                        opacity: 1;
                    }
                }

                @keyframes progressBar {
                    from { width: 100%; }
                    to { width: 0%; }
                }

                @keyframes bellShake {
                    0%, 50%, 100% { transform: rotate(0deg); }
                    10%, 30% { transform: rotate(-10deg); }
                    20%, 40% { transform: rotate(10deg); }
                }

                @keyframes pulse {
                    0% { 
                        transform: scale(1); 
                        opacity: 1; 
                    }
                    50% { 
                        transform: scale(1.2); 
                        opacity: 0.7; 
                    }
                    100% { 
                        transform: scale(1); 
                        opacity: 1; 
                    }
                }

                @keyframes bounce {
                    0%, 20%, 50%, 80%, 100% { 
                        transform: translateY(0); 
                    }
                    40% { 
                        transform: translateY(-10px); 
                    }
                    60% { 
                        transform: translateY(-5px); 
                    }
                }

                @keyframes ping {
                    0% { 
                        transform: scale(1); 
                        opacity: 1; 
                    }
                    75%, 100% { 
                        transform: scale(1.5); 
                        opacity: 0; 
                    }
                }

                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }

                @keyframes animate-swing {
                    0%, 100% { transform: rotate(0deg); }
                    25% { transform: rotate(15deg); }
                    75% { transform: rotate(-15deg); }
                }

                /* Mobile Responsiveness */
                @media (max-width: 768px) {
                    .notification-alert {
                        top: 10px;
                        right: 10px;
                        left: 10px;
                        min-width: auto;
                        max-width: none;
                    }

                    .notification-panel {
                        width: 300px;
                        right: -50px;
                    }

                    .appointments-header .d-flex {
                        flex-direction: column;
                        gap: 1rem;
                    }

                    .notification-content {
                        padding: 15px;
                    }
                }

                @media (max-width: 480px) {
                    .notification-panel {
                        width: 280px;
                        right: -80px;
                    }
                }

                /* Sound Wave Animation for Bell */
                .animate-swing {
                    animation: animate-swing 0.8s ease-in-out infinite;
                }

                /* Custom Scrollbar for Notification Panel */
                .notification-panel-body::-webkit-scrollbar {
                    width: 4px;
                }

                .notification-panel-body::-webkit-scrollbar-track {
                    background: rgba(255, 255, 255, 0.1);
                    border-radius: 10px;
                }

                .notification-panel-body::-webkit-scrollbar-thumb {
                    background: rgba(255, 255, 255, 0.3);
                    border-radius: 10px;
                }

                .notification-panel-body::-webkit-scrollbar-thumb:hover {
                    background: rgba(255, 255, 255, 0.5);
                }

.notification-sound-btn {
    background: rgba(255, 255, 255, 0.1);
    border: none;
    border-radius: 12px;
    padding: 0.75rem;
    color: white;
    transition: all 0.3s ease;
}

.notification-sound-btn:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: scale(1.05);
}

.notification-sound-btn.muted {
    background: rgba(255, 0, 0, 0.3);
    color: #ff6b6b;
}
            `}</style>
        </>
    )
}